import React from "react";
import {
  Badge,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown as ReactStrapDropDown,
} from "reactstrap";
import Item from "./Item";
import style from "./../style.module.scss";
import ModalDetail from "../ModalDetail";

class List extends React.Component {
  state = {
    open: false,
    modalDetail: {
      open: false,
    },
  };

  toggle = () => {
    this.setState({ open: !this.state.open });
  };

  toggleModal = (name, props) => {
    this.setState({ [name]: { open: !this.state[name].open, ...props } });
  };

  handleItemClick = ({ id, process, ...props }) => {
    this.props.fetchMarkAsRead({ id });
  };

  render() {
    const { open, modalDetail } = this.state;
    const { link, routes } = this.props;
    let { items } = this.props;

    items = sortItemsFirst15(items);

    const eventsCounter = items ? items.length : "-";
    return [
      <ReactStrapDropDown nav isOpen={open} toggle={this.toggle} key={`event-alert-list`}>
        <DropdownToggle nav>
          <span>
            <i className="icon-bell"></i>
            <Badge pill color="danger">
              {eventsCounter}
            </Badge>
          </span>
        </DropdownToggle>
        <DropdownMenu right>
          <div className={style.container}>
            <DropdownItem header tag="div" className="text-center">
              <strong>Events unread</strong>
            </DropdownItem>
            {items && items.length == 0 && (
              <h6 className={style.empty} style={{ textAlign: "center" }}>
                No events
              </h6>
            )}
            {items &&
              items.map((item, i) => (
                <Item
                  key={`di-${i}`}
                  item={item}
                  tag={link}
                  route={getRoute(routes, item.process)}
                  onClick={() => this.handleItemClick(item)}
                />
              ))}
          </div>
          <DropdownItem tag={link} to={routes["ViewAll"].to} className={`view-more ${style.more}`}>
            View all events
          </DropdownItem>
        </DropdownMenu>
      </ReactStrapDropDown>,

      <ModalDetail
        key={`event-alert-detail`}
        {...modalDetail}
        toggle={() => this.toggleModal("modalDetail")}
      />,
    ];
  }
}

function sortItemsFirst15(items) {
  if (items == null) return;

  items = items.slice(0, 15);
  items.sort((i1, i2) => {
    const compare_dateTime = new Date(i2.dateTime) - new Date(i1.dateTime);
    const compare_read = i2.read - i1.read;

    return compare_read || compare_dateTime;
  });

  return items;
}

export function getRoute(routes, process) {
  const route = routes[process] || { to: "/" };

  return route.to;
}

export default List;
